var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-form-wrapper',{attrs:{"label":_vm.label,"name":_vm.name,"size":_vm.size,"prefill":_vm.prefill}},[_c('div',{staticClass:"input-container"},[_vm._t("default"),_c('vue-editor',{attrs:{"editorOptions":_vm.editorOptions},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }